const settings = (state: any) => {
  const { home } = state
  const brands = state?.globals?.header?.partnerCategories
  const isDefaultStore =
    home?.brands?.meta?.defaultStore?.storeId ===
    home?.brands?.meta?.currentStore?.storeId
  const variableWidth = brands?.length < 9 ? true : false
  const className = brands?.length < 9 ? 'slick-slide-content' : ''

  return {
    arrows: true,
    autoplay: false,
    dots: false,
    infinite: brands?.length < 9 ? false : true,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          dots: false,
          slidesToScroll: isDefaultStore ? 9 : 6,
          slidesToShow: isDefaultStore ? 9 : 6,
          variableWidth: variableWidth,
          className: className,
        },
      }
    ],
    variableWidth: variableWidth,
    className: className,
  }
}

export default settings
